<template>
  <div class="content">
    <base-block class="mb-0" rounded title="Edit Topic">
      <div class="row">
        <div class="col-md-6 form-group">
          Select Topic
          <b-form-select v-model="topic" :options="topicOption"></b-form-select>
        </div>
        <div class="col-md-6 form-group">
          Name
          <input class="form-control" type="text" />
        </div>
        <div class="col-md-6 form-group">
          Description
          <input class="form-control" type="text" />
        </div>
        <div class="col-md-6 form-group">
          Topic Type
          <b-form-select v-model="selected2" :options="options2"></b-form-select>
        </div>
        <div class="col-md-6 form-group">
          Status
          <b-form-select v-model="selected1" :options="options1"></b-form-select>
        </div>
      </div>
      <div class="text-center">
        <b-button
          class="text-center pt-2 pb-2 pr-4 pl-4"
          variant="success"
          style="margin-bottom: 20px"
          >Save</b-button
        >
      </div>
    </base-block>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selected1: "",
      options1: [{ text: "Active" }, { text: "Deactive" }],
      selected2: "",
      options2: [{ text: "Free" }, { text: "Paid" }],
      topic: "",
      topicOption: [{ text: "Quantitative" }, { text: "Verbal" }, { text: "Reasoning"}]
    };
  },
};
</script>

